import React, { Component } from 'react';
import SlotMachine from './slotComponents/SlotMachine';
import BaseComponent from '../../components/system/base';
import { Shake } from 'reshake'

class SlotShell extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      text: this.translate["popToWin"]
    }
    this.printPrize = this.printPrize.bind(this);
  }
  render() {
    return (
      <React.Fragment>
        <div className="center" style={{marginTop: 20}}>
          <Shake
            h={9}
            v={5}
            r={52}
            dur={1000}
            int={91.1}
            max={100}
            fixed={true}
            fixedStop={false}
            freez={false}>
              <img style={{marginTop: 5, width: "100%"}} src="/images/content/slot/Fish.png" style={{width: 150}} alt="Main Fish"/>
          </Shake>
        </div>
        <div style={{marginTop: 15}}>
          <h1 className="slot">{this.state.text}</h1>
          <SlotMachine prize={this.printPrize} />
        </div>
      </React.Fragment>
    );
  }
  printPrize(text) {
    this.setState({
      text: text
    })
  }

}

export default SlotShell;



// WEBPACK FOOTER //
// ./src/content/winPrize/slotShell.js